import { TrackingEvent } from '@manakincubber/tiime-tracking';

export const FORMALITY_CARDS_VIEWED = 'Formality Cards Viewed';

export class FormalityCardsViewed implements TrackingEvent {
  readonly name = FORMALITY_CARDS_VIEWED;
}
